import { Link } from 'react-router-dom';
import { useT } from '../i18n/I18nContext';
import { KYLOO_VERSION } from '../version';

export default function Footer({ variant = 'light' }) {
  const { t } = useT();
  const isDark = variant === 'dark';
  const linkClass = isDark
    ? 'text-white/60 hover:text-white'
    : 'text-slate-500 hover:text-slate-700';
  const dividerClass = isDark ? 'text-white/30' : 'text-slate-300';
  const brandClass = isDark ? 'text-white/40' : 'text-slate-400';

  return (
    <footer className="px-4 py-6 mt-8" data-testid="footer">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-2 text-xs">
        <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <Link to="/privacy" className={linkClass} data-testid="footer-privacy">{t('footer.privacy')}</Link>
          <span className={dividerClass}>·</span>
          <Link to="/termini" className={linkClass} data-testid="footer-terms">{t('footer.terms')}</Link>
          <span className={dividerClass}>·</span>
          <Link to="/cookie" className={linkClass} data-testid="footer-cookie">{t('footer.cookie')}</Link>
          <span className={dividerClass}>·</span>
          <a
            href="mailto:kyloo.app@libero.it"
            className={linkClass}
            data-testid="footer-contact"
          >
            {t('footer.contact')}
          </a>
        </nav>
        <p className={brandClass}>
          {t('footer.copyright', { year: new Date().getFullYear() })}
          {' · '}
          <span data-testid="kyloo-version">Kyloo {KYLOO_VERSION}</span>
        </p>
      </div>
    </footer>
  );
}
